import {
  inject, observer,
} from 'mobx-react';
import {
  WithSnackbarProps,
} from 'notistack';
import React, {
  Component,
} from 'react';
import GeneralSearchComponent from '../../components/GeneralCRUDComponent/GeneralSearchComponent/GeneralSearchComponent';
import GeneralTableComponent from '../../components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import {
  TableCellTypes,
} from '../../components/GeneralCRUDComponent/TableCellTypes/TableCellTypes';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';
import {
  translate,
} from '../../helperFunctions/translation';
import {
  Branch, IBranchStore,
} from '../../mobx-store/storeInterfaces/branchInterface';
import {
  CountryStore,
} from '../../mobx-store/stores/countryStore';
import { languageCodes } from '../../constants/languages';

interface IProps extends WithSnackbarProps {
  branchStore: IBranchStore;
  countryStore: CountryStore;
  history: any;
}

interface TableData {
  title: string;
  isActive: boolean;
  edit: string;
}

@inject('branchStore')
@inject('countryStore')
@observer
class Branches extends Component<IProps> {
  addButton: any;

  tableHeader: any = [];

  tableData: TableData[] = [];

  tableCellTypes: TableCellTypes[] = [];

  title = 'Branches Management';

  constructor(props: IProps) {
    super(props);
  }

  handleTableToggleCellChange = (index: number, key: string, value: boolean) => {
    this.props.branchStore.updateBranchStatus(value, index)
      .then(() => {
        SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {
        }), 8000, 'success');
      })
      .catch((error: any) => {
        SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
        }), 8000, 'error');
      });
  };

  handleTableButtonCellClicked = (index: number, key: string) => {
    console.log(index, key);
    this.props.history.push(`/branches/${this.props.branchStore.branchesList[index].getId()}/edit`);
    // this.setState({ [name]: event.target.checked });
  };

  handelAdd = (): void => {
    this.props.history.push('/branches/new');
    console.log('add');
  };

  getAddBranchButton = () => ({
    title: 'Add',
    onAdd: this.handelAdd,
  });

  getBranchTableHeader = () => [
    {
      title: 'Branch',
    },
    {
      title: 'Status',
    },
    {
      title: 'Edit',
    },
  ];

  getBranchTableData = () => this.props.branchStore.branchesList
    .map((branch: Branch) => {
      const branchData = {
        title: branch.getTitle(),
        isActive: branch.getIsActive(),
        edit: 'Edit',
      };
      return branchData;
    });

  getBranchTableCellTypes = (): TableCellTypes[] => [
    {
      cellType: 'Text',
      key: 'title',
    },
    {
      cellType: 'ToggleButton',
      key: 'isActive',
      activeLabel: 'Active',
      inactiveLabel: 'Not active',
      onChange: this.handleTableToggleCellChange,
    },
    {
      cellType: 'Button',
      key: 'edit',
      onClick: this.handleTableButtonCellClicked,
    },
  ];

  handleSearchChanged = (title: any) => {
    title ? this.props.branchStore.filterBranches(this.props.countryStore.managedCountries, title, languageCodes.english)
      : this.props.branchStore.getBranches(this.props.countryStore.managedCountries, languageCodes.english);
  };

  render() {
    this.addButton = this.getAddBranchButton();
    this.tableHeader = this.getBranchTableHeader();
    this.tableData = this.getBranchTableData();
    this.tableCellTypes = this.getBranchTableCellTypes();
    return (
      <div>
        <GeneralSearchComponent onSearchClick={this.handleSearchChanged} searchBy="title" />
        <GeneralTableComponent
          emptyMessage="There are no branches yet. Please add one now"
          title={this.title}
          tableHeader={this.tableHeader}
          tableData={this.tableData}
          tableCellTypes={this.tableCellTypes}
          addButton={this.addButton}
          loadingStatus={[
            this.props.branchStore.getBranchesRequestStatus,
            this.props.countryStore.getManagedCountriesRequestStatus
          ]}
        />
      </div>
    );
  }

  async componentDidMount() {
    const {
      countryStore, branchStore,
    } = this.props;
    await countryStore.getUserManagedCountries();

    branchStore.getBranches(countryStore.managedCountries, languageCodes.english);
  }
}

export default Branches;
